import React from 'react'; 
import { FunctionFactory } from 'survey-core';
import { BodyType } from '../quiz/bodytype';

const bodyTypeSplashHtml =`
<div class="new-quote-container centered">
  <div class="splash-icon">{bodyTypeIcon}</div>
  <div class="splash-header">
    <h1>{bodyTypeTitle}</h1>
    <div class="quote">{bodyTypeContent}</div>
  </div>
</div>`;

const bodyTypeSplashContentMap = {
    [BodyType.Skinny]: {
      icon: "📍",
      title: `You’re in the right place, <div class="highlight"><span>{name}</span>!</div>`,
      text: "This body type takes a targeted approach, and that’s exactly what you’ll get. Most people never get past this stage, and you’re already on your way out of it.",
    },
    [BodyType.SkinnyFat]: {
      icon: "📍",
      title: `You’re in the right place, <div class="highlight"><span>{name}</span>!</div>`,
      text: "This body type takes a targeted approach, and that’s exactly what you’ll get. Most people never get past this stage, and you’re already on your way out of it.",
    },
    [BodyType.Defined]: {
      icon: "📍",
      title: `You’re in a great spot, <div class="highlight"><span>{name}</span>!</div>`,
      text: "You’ve done the work and you’re already doing great. We’ll help you build on that with healthy habits that support your goals for the long-term.",
    },
    [BodyType.Athletic]: {
      icon: "📍",
      title: `You’re in a great spot, <div class="highlight"><span>{name}</span>!</div>`,
      text: "You’ve done the work and you’re already doing great. We’ll help you build on that with healthy habits that support your goals for the long-term.",
    },
    [BodyType.Bulky]: {
      icon: "📍",
      title: `You’re in a great spot, <div class="highlight"><span>{name}</span>!</div>`,
      text: "You've done the hard work of building muscle. Lowering your body fat without losing your hard earned muscle will help you build a lean, muscular, athletic physique.",
    },
    [BodyType.Overweight]: {
      icon: "🤝",
      title: `We’ve got you, <div class="highlight"><span>{name}</span>!</div>`,
      text: "We'll help you take a gradual, sustainable approach towards your goals. We want to help you lose the fat, and keep it off for good.",
    },
} as const;

function renderBodyTypeSplashIcon(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  return bodyTypeSplashContentMap[params[0] as BodyType].icon;
}
FunctionFactory.Instance.register("bodyTypeSplashIcon", renderBodyTypeSplashIcon);
const bodyTypeSplashIconExpression = {
  name: "bodyTypeIcon",
  expression: "bodyTypeSplashIcon({bodyType})",
};

function renderBodyTypeSplashTitle(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  const bodyType = params[0] as BodyType;
  return bodyTypeSplashContentMap[bodyType].title;
}
FunctionFactory.Instance.register("bodyTypeSplashTitle", renderBodyTypeSplashTitle);
const bodyTypeSplashTitleExpression = {
  name: "bodyTypeTitle",
  expression: "bodyTypeSplashTitle({bodyType})",
};

function renderBodyTypeSplashContent(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  const bodyType = params[0] as BodyType;
  return bodyTypeSplashContentMap[bodyType].text;
}
FunctionFactory.Instance.register("bodyTypeSplashContent", renderBodyTypeSplashContent);
const bodyTypeSplashContentExpression = {
  name: "bodyTypeContent",
  expression: "bodyTypeSplashContent({bodyType})",
};

const bodyTypeSplashElement = {
  name: "body-type-splash",
  type: "html",
  html: bodyTypeSplashHtml,
}

const BodyTypeSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🔬 Your profile is coming into focus
    </div>
  )
}

export {
  bodyTypeSplashElement,
  bodyTypeSplashIconExpression,
  bodyTypeSplashTitleExpression,
  bodyTypeSplashContentExpression,
  BodyTypeSplashHeader,
}
